export function formatCaseId(caseId?: number | null): string {
	return String(caseId ?? 0).padStart(6, "0");
}
